import styled from 'styled-components'

import { Infos as GSInfos } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { borderWidths, colors, fontSizes, media, radii, space } = theme

export const TipsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};
  margin-top: ${space['spacing-xl']};

  @media (${media.tablet}) {
    margin-top: ${space['spacing-giga']};
    flex-direction: row;
  }
`

export const Infos = styled(GSInfos)`
  max-width: unset;
`

export const Card = styled.div`
  width: 100%;
  padding: ${space['spacing-sm']};
  border: ${borderWidths['border-stroke-micro']} solid ${colors['neutral-border-default']};
  border-radius: ${radii['corner-radius-md']};
  background-color: ${colors['neutral-background-default']};

  h3 {
    margin-bottom: 14px;
  }

  @media (${media.desktop}) {
    h3 {
      font-size: ${fontSizes['font-size-heading-5']};
    }
  }
`
export const CardIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${space['spacing-xl']};
  height: ${space['spacing-xl']};
  margin-bottom: ${space['spacing-sm']};
  border-radius: ${radii['corner-radius-circular']};
  background-color: ${colors['neutral-background-medium']};
`
